/* TitanBanks FLASH: injecteert zwevende embers in donkere secties.
   Deterministische pseudo-random posities (geen layout-werk, puur transform/opacity). */
(function () {
  function seedRand(seed) {
    return function () {
      seed = (seed * 9301 + 49297) % 233280;
      return seed / 233280;
    };
  }

  function addEmbers(el, count, seed) {
    if (!el || el.querySelector('.tb-embers')) return;
    var wrap = document.createElement('div');
    wrap.className = 'tb-embers';
    wrap.setAttribute('aria-hidden', 'true');
    var rnd = seedRand(seed);
    for (var i = 0; i < count; i++) {
      var s = document.createElement('span');
      s.style.setProperty('--x', (rnd() * 96 + 2).toFixed(1) + '%');
      s.style.setProperty('--d', (rnd() * 6 + 7).toFixed(1) + 's');
      s.style.setProperty('--delay', (rnd() * -12).toFixed(1) + 's');
      s.style.setProperty('--s', (rnd() * 0.8 + 0.5).toFixed(2));
      s.style.setProperty('--drift', ((rnd() - 0.5) * 90).toFixed(0) + 'px');
      wrap.appendChild(s);
    }
    el.prepend(wrap);
  }

  function init() {
    addEmbers(document.querySelector('.tb-specs'), 10, 7);
    addEmbers(document.querySelector('.tb-cta'), 16, 21);
    addEmbers(document.querySelector('.tb-detail'), 8, 42);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
